function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 286.036 286.036",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M231.641 113.009c-3.915-40.789-37.875-72.792-79.684-72.792-32.351 0-60.053 19.201-72.819 46.752-3.844-1.225-7.849-2.056-12.095-2.056-22.214 0-40.226 18.021-40.226 40.226 0 4.416.885 8.591 2.199 12.551C11.737 147.765 0 166.26 0 187.696c0 32.092 26.013 58.105 58.105 58.105v.018h160.896v-.018c37.044 0 67.035-30.009 67.035-67.044 0-32.682-23.421-59.83-54.395-65.748zm-54.833 51.463h-15.912v35.864c0 4.943-3.987 8.957-8.939 8.957h-17.878c-4.934 0-8.939-4.014-8.939-8.957v-35.864h-15.921c-9.708 0-13.668-6.481-8.823-14.383l33.799-33.316c6.624-6.615 10.816-6.838 17.646 0l33.799 33.316c4.863 7.911.876 14.383-8.832 14.383z",
    style: {},
    fill: "#9dcfc7",
    "data-original": "#39b29d",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.300d819e1f38243791d7dba519bb0eee.svg";
export { ForwardRef as ReactComponent };